import { render, staticRenderFns } from "./ClientActivity.vue?vue&type=template&id=b2243c12&scoped=true&"
import script from "./ClientActivity.vue?vue&type=script&lang=js&"
export * from "./ClientActivity.vue?vue&type=script&lang=js&"
import style0 from "./ClientActivity.vue?vue&type=style&index=0&id=b2243c12&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b2243c12",
  null
  
)

export default component.exports